module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ehaMc"))).then(() => parcelRequire('dJXJK'));